export const logicaTomarTurno = (
  turnosDisponibles,
  ordenDigitalState,
  turno,
  selectDropDown,
  pacienteAuth,
  configState,
  type,
  dtoNuevaBusqueda,
  idProtocolo,
  osAlternativa
) => {
  const esParticular =
    turnosDisponibles.turnosDisponibles.turnosData.dtoBusqueda
      .flgEspecialidadPart;
  const esPorVideollamada =
    turnosDisponibles.turnosDisponibles.turnosData.dtoBusqueda.videoConsulta;
  const idTurno = turno.idTurno;
  const idTurnoCombinado = turno.idTurnoCombinadoturno || 0;
  const familiar = selectDropDown.selectDropDown.selectGlobal.pacienteElegido;
  const ordenDigital = ordenDigitalState.ordenDigital.altaTurno;
  const ordenDigitalMedico = ordenDigitalState.ordenDigital.idMedSolicitante;
  const versionFront = configState.config.data.version;
  const idFront = configState.config.data.sectorVersion;
  let accion = sessionStorage.getItem("accionHash");
  // const familiarConsultaMedica = selectDropDown.selectDropDown.consulMedica.pacienteElegido;
  // const familiarEstudios = selectDropDown.selectDropDown.estudios.pacienteElegido;
  // const familiarLaboratorio = selectDropDown.selectDropDown.laboratorio.pacienteElegido;
  if (type === "CONSULTA_MEDICA" && familiar) {
    let dtoTomarTurno = {
      idTurno: idTurno,
      idGrupoMedico: 0,
      idObraSocial: familiar.paciente.obra_social,
      idPaciente: familiar.paciente.id,
      idPlan: familiar.paciente.idplan,
      operador: accion ? "BOT" : "",
      tipoiva: familiar.paciente.tipoiva,
      particular: esParticular,
      videoConsulta: esPorVideollamada,
      sectorTurno: process.env.SECTOR_TURNO,
      descripcion: turno.medico,
      idFront: idFront,
      versionFront: versionFront,
    };
    return { dto: dtoTomarTurno, idFamiliar: familiar.paciente.id };
  } else if (type === "CONSULTA_MEDICA") {
    let dtoTomarTurno = {
      idTurno: idTurno,
      idGrupoMedico: 0,
      idObraSocial: pacienteAuth.auth.data.paciente.obraSocial,
      idPaciente: pacienteAuth.auth.data.paciente.codigo,
      idPlan: pacienteAuth.auth.data.paciente.idPlan,
      operador: accion ? "BOT" : "",
      sectorTurno: process.env.SECTOR_TURNO,
      tipoiva: pacienteAuth.auth.data.paciente.tipoIva,
      particular: esParticular,
      videoConsulta: esPorVideollamada,
      descripcion: turno.medico,
      idFront: idFront,
      versionFront: versionFront,
    };

    return { dto: dtoTomarTurno, idFamiliar: false };
  }
  if (
    type === "ESTUDIOS" &&
    turnosDisponibles.turnosDisponibles.turnosData.volverOrigen !==
      "CONSULTA_MEDICA" &&
    familiar
  ) {
    let dtoTomarTurno = {
      ...dtoNuevaBusqueda,
      idTurno: idTurno,
      idPlan: familiar.paciente.idplan,
      sectorTurno: process.env.SECTOR_TURNO,
      videoAtencion:
        turnosDisponibles.turnosDisponibles.turnosData.dtoBusqueda
          .videoAtencion,
      idGrupoMedico:
        turnosDisponibles.turnosDisponibles.turnosData.dtoBusqueda
          .idGrupoMedico,
      GruposMedico: turnosDisponibles.turnosDisponibles.turnosData.GruposMedico,
      tipoiva: familiar.paciente.tipoiva,
      idOrdenDigital: ordenDigital ? ordenDigital : -1,
      idMedSolicitante: ordenDigitalMedico !== null ? ordenDigitalMedico : "",
      idTurnoCombinado: idTurnoCombinado,
      idFront: idFront,
      versionFront: versionFront,
    };
    return { dto: dtoTomarTurno, idFamiliar: familiar.paciente.id };
  } else if (
    type === "ESTUDIOS" &&
    turnosDisponibles.turnosDisponibles.turnosData.volverOrigen !==
      "CONSULTA_MEDICA"
  ) {
    let dtoTomarTurno = {
      ...dtoNuevaBusqueda,
      idTurno: idTurno,
      idPlan: pacienteAuth.auth.data.paciente.idPlan,
      sectorTurno: process.env.SECTOR_TURNO,
      videoAtencion:
        turnosDisponibles.turnosDisponibles.turnosData.dtoBusqueda
          .videoAtencion,
      idGrupoMedico:
        turnosDisponibles.turnosDisponibles.turnosData.dtoBusqueda
          .idGrupoMedico,
      GruposMedico: turnosDisponibles.turnosDisponibles.turnosData.GruposMedico,
      tipoiva: pacienteAuth.auth.data.paciente.tipoIva,
      idOrdenDigital: ordenDigital ? ordenDigital : -1,
      idMedSolicitante: ordenDigitalMedico !== null ? ordenDigitalMedico : "",
      idTurnoCombinado: idTurnoCombinado,
      idFront: idFront,
      versionFront: versionFront,
    };

    return { dto: dtoTomarTurno, idFamiliar: false };
  } else if (
    type === "ESTUDIOS" &&
    turnosDisponibles.turnosDisponibles.turnosData.volverOrigen ===
      "CONSULTA_MEDICA" &&
    !familiar
  ) {
    let dtoTomarTurno = {
      ...dtoNuevaBusqueda,
      idTurno: idTurno,
      idPlan: pacienteAuth.auth.data.paciente.idPlan,
      sectorTurno: process.env.SECTOR_TURNO,
      videoAtencion:
        turnosDisponibles.turnosDisponibles.turnosData.dtoBusqueda
          .videoAtencion,
      idGrupoMedico:
        turnosDisponibles.turnosDisponibles.turnosData.dtoBusqueda
          .idGrupoMedico,
      GruposMedico: turnosDisponibles.turnosDisponibles.turnosData.GruposMedico,
      tipoiva: pacienteAuth.auth.data.paciente.tipoIva,
      idTurnoCombinado: idTurnoCombinado,
      idFront: idFront,
      versionFront: versionFront,
    };
    return { dto: dtoTomarTurno, idFamiliar: false };
  } else if (
    type === "ESTUDIOS" &&
    turnosDisponibles.turnosDisponibles.turnosData.volverOrigen ===
      "CONSULTA_MEDICA" &&
    familiar
  ) {
    let dtoTomarTurno = {
      ...dtoNuevaBusqueda,
      idTurno: idTurno,
      idPlan: familiar.paciente.idplan,
      idObraSocial: familiar.paciente.obra_social,
      idPaciente: familiar.paciente.id,
      sectorTurno: process.env.SECTOR_TURNO,
      videoAtencion:
        turnosDisponibles.turnosDisponibles.turnosData.dtoBusqueda
          .videoAtencion,
      idGrupoMedico:
        turnosDisponibles.turnosDisponibles.turnosData.dtoBusqueda
          .idGrupoMedico,
      GruposMedico: turnosDisponibles.turnosDisponibles.turnosData.GruposMedico,
      tipoiva: familiar.paciente.tipoiva,
      idTurnoCombinado: idTurnoCombinado,
      idFront: idFront,
      versionFront: versionFront,
    };
    return { dto: dtoTomarTurno, idFamiliar: familiar.paciente.id };
  }
  if (
    idProtocolo !== null &&
    idProtocolo !== undefined &&
    idProtocolo !== "-1" &&
    !familiar
  ) {
    let dtoTomarTurno = {
      id: idTurno,
      IdGrupoEstAlta: dtoNuevaBusqueda.idGrupo,
      IdGrupoEstudio: dtoNuevaBusqueda.idGrupo,
      esParticular: turnosDisponibles.turnosDisponibles.turnosData.particular,
      IdProtocoloAlta: idProtocolo,
      OsAlternativa: osAlternativa,
      idFront: idFront,
      versionFront: versionFront,
    };
    return { dto: dtoTomarTurno, idFamiliar: false };
  } else {
    if (type === "LABORATORIO" && familiar) {
      let dtoTomarTurno = {
        id: idTurno,
        IdGrupoEstAlta: dtoNuevaBusqueda.idGrupo,
        IdGrupoEstudio: dtoNuevaBusqueda.idGrupo,
        sectorTurno: process.env.SECTOR_TURNO,
        esParticular: turnosDisponibles.turnosDisponibles.turnosData.particular,
        tipoiva: familiar.paciente.tipoiva,
        IdProtocoloAlta: idProtocolo,
        OsAlternativa: osAlternativa,
        idFront: idFront,
        versionFront: versionFront,
      };
      return { dto: dtoTomarTurno, idFamiliar: familiar.paciente.id };
    } else if (type === "LABORATORIO") {
      let dtoTomarTurno = {
        id: idTurno,
        IdGrupoEstAlta: dtoNuevaBusqueda.idGrupo,
        IdGrupoEstudio: dtoNuevaBusqueda.idGrupo,
        sectorTurno: process.env.SECTOR_TURNO,
        esParticular: turnosDisponibles.turnosDisponibles.turnosData.particular,
        tipoiva: pacienteAuth.auth.data.paciente.tipoIva,
        OsAlternativa: osAlternativa,
        idFront: idFront,
        versionFront: versionFront,
      };
      return { dto: dtoTomarTurno, idFamiliar: false };
    }
  }
};

/**
 * Valida el DTO de toma de estudios antes de enviarlo. GruposMedico viene del
 * estado compartido turnosDisponibles; si lo escribió una instancia del buscador
 * que no hizo la búsqueda, llega con Id "" y el backend responde 400
 * ("$.GruposMedico[0].Id could not be converted to System.Int64").
 * Acepta Id o id (BuscadorEstudio guarda los grupos en minúscula).
 */
export const esDtoEstudiosValido = (dto) => {
  if (!dto || !Array.isArray(dto.GruposMedico) || dto.GruposMedico.length === 0) {
    return false;
  }
  return dto.GruposMedico.every((grupo) => {
    const crudo = grupo ? (grupo.Id !== undefined ? grupo.Id : grupo.id) : undefined;
    if (crudo === undefined || crudo === null || crudo === "") return false;
    const id = Number(crudo);
    return Number.isInteger(id) && id > 0;
  });
};
